import { LinearProgress } from "@mui/material";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import CloseIcon from "@mui/icons-material/Close";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import styles from "../FileExplorer.module.scss";

/**
 * Floating bottom-right widget shown while an upload runs in the background
 * (after the user minimises the modal). Shows live progress and a success
 * state, plus a warning not to refresh the page.
 */
const UploadProgressWidget = ({
  value,
  uploadedCount,
  total,
  completed,
  onExpand,
  onClose,
}) => {
  return (
    <div className={styles.uploadWidget}>
      <div className={styles.widgetHead}>
        <span className={styles.widgetTitle}>
          {completed ? (
            <CheckCircleIcon className={styles.widgetDoneIcon} fontSize="small" />
          ) : (
            <CloudUploadOutlinedIcon fontSize="small" />
          )}
          {completed ? "Upload complete" : "Uploading files"}
        </span>
        <span className={styles.widgetActions}>
          {!completed && (
            <OpenInFullIcon
              className={styles.widgetIconBtn}
              fontSize="small"
              onClick={onExpand}
              titleAccess="Expand"
            />
          )}
          {completed && (
            <CloseIcon
              className={styles.widgetIconBtn}
              fontSize="small"
              onClick={onClose}
              titleAccess="Dismiss"
            />
          )}
        </span>
      </div>

      <div className={styles.widgetBody}>
        {completed ? (
          <div className={styles.widgetSuccess}>
            All {total} file{total > 1 ? "s" : ""} uploaded successfully.
          </div>
        ) : (
          <>
            <div className={styles.widgetRow}>
              <span>
                {uploadedCount} / {total} files
              </span>
              <span>{Math.round(value)}%</span>
            </div>
            <LinearProgress
              variant="determinate"
              value={value}
              className={styles.widgetBar}
            />
            <div className={styles.widgetWarn}>
              <WarningAmberOutlinedIcon fontSize="inherit" />
              Please don’t refresh or close this page.
            </div>
          </>
        )}
      </div>

      {!completed && (
        <button
          type="button"
          className={styles.widgetExpandBtn}
          onClick={onExpand}
        >
          View details
        </button>
      )}
    </div>
  );
};

export default UploadProgressWidget;
